import React from 'react';
import { Clock, CheckCircle, XCircle, Ban, Trash2 } from 'lucide-react';
import './StatusBadge.css';

const STATUS_CONFIG = {
  pending: { label: 'Pending', icon: Clock, className: 'badge-pending' },
  approved: { label: 'Approved', icon: CheckCircle, className: 'badge-approved' },
  denied: { label: 'Denied', icon: XCircle, className: 'badge-denied' },
  cancelled: { label: 'Cancelled', icon: Ban, className: 'badge-cancelled' },
  removed: { label: 'Removed', icon: Trash2, className: 'badge-removed' },
};

function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = config.icon;

  return (
    <span className={`status-badge ${config.className}`}>
      <Icon size={12} />
      <span>{config.label}</span>
    </span>
  );
}

export default StatusBadge;
